// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"ed8b1a51","305":"852de871","926":"33f71232"}[chunkId] + ".chunk.js";
};